import { useCallback, useRef, useEffect } from "react";

/**
 * Custom hook for creating sliding animation effects.
 * Manages element references and accessibility attributes.
 *
 * @param isOpen - Boolean state that determines if content is expanded
 * @param onToggle - Optional callback when toggle state changes
 * @returns Object with refs and helper methods
 */
export const useSlideToggle = (
	isOpen: boolean,
	onToggle?: (isOpen: boolean) => void
) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const firstFocusableRef = useRef<HTMLElement | null>(null);

	// Toggle handler with callback
	const toggle = useCallback(() => {
		onToggle?.(!isOpen);
	}, [isOpen, onToggle]);

	return {
		containerRef,
		toggle,
		isOpen,
	};
};
